import styled from 'styled-components';

export const DropdownMenuItemLi = styled.li`
  list-style: none;
  margin: 0;
  padding: 0;
`;
